$(function() {

	$('a[href$="e-shop.html"]').attr('target', '_blank');

});